































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { isFunction } from 'lodash';
import { GridApi } from 'ag-grid-community';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import {
  FormFieldDefMap,
  emitFormChangeEvent,
} from '@/reusable/Form/formUtils';
import moment from 'moment';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { TipoDocumento } from '@/pantallas/Facturacion/fetchTipoDocumento';
import { TipoEstado } from '@/pantallas/Facturacion/fetchEstados';
@Component({
  components: {
    DatePicker,
    FormFieldsContainer,
  },
})
export default class BuscadorFacturacion extends Vue {
  @Prop() listaEstados: TipoEstado[];
  @Prop() listaTipoDocumentos: TipoDocumento[];

  formFields: FormFieldDefMap = {
    fechaInicio: {
      label: 'Fecha Desde',
      id: 'fechaInicio',
      value: moment(this.fechaMinima),
    },
    fechaTermino: {
      label: 'Fecha Hasta',
      id: 'fechaTermino',
      value: moment(this.fechaMaxima),
    },
    tipoDocumento: {
      label: 'Tipo de Documento',
      id: 'tipoDocumento',
      value: '',
    },
    nroDcto: {
      label: 'Nro. de Documento',
      id: 'nroDcto',
      value: '',
    },
    estado: {
      label: 'Estado',
      id: 'estado',
      value: '',
    },
  };

  handleBuscarClick() {
    this.$emit('resultadoBusqueda', this.formFields);
  }

  @Watch('formFields', { deep: true })
  handleFormChange(fields: FormFieldDefMap) {
    emitFormChangeEvent(this.$emit.bind(this), {
      entity: {
        fechaInicio: fields.fechaInicio.value,
        fechaTermino: fields.fechaTermino.value,
      } as any,
    });
  }

  get fechaMaxima() {
    let fechaMax: any = new Date().toISOString().substr(0, 10);
    return fechaMax;
  }

  get fechaMaximaInicio() {
    //let fechaMax: any = new Date().toISOString().substr(0, 10);
    let fechaMax = this.formFields.fechaTermino.value;
    return fechaMax as moment.Moment;
  }

  get fechaMinimaInicio() {
    //let fechaMax: any = new Date().toISOString().substr(0, 10);
    let fechaIni = this.formFields.fechaInicio.value;
    return fechaIni as moment.Moment;
  }

  get fechaMinima() {
    let fechaMin = moment(new Date())
      .add(-12, 'months')
      .toISOString()
      .substr(0, 10);
    return fechaMin;
  }

  clearFilters() {
    this.formFields.fechaInicio.value = moment(this.fechaMinima);
    this.formFields.fechaTermino.value = moment(this.fechaMaxima);
    this.formFields.tipoDocumento.value = '';
    this.formFields.nroDcto.value = '';
    this.formFields.estado.value = '';
    this.$emit('clear');
  }
}
